// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.pb-5 {
  padding-bottom: 5rem !important;
}

p-columnFilter {
  margin-left: var(--spacer3);
}

.have-filter p-columnFilter {
  display: inline-block;
}

.button-loading {
  position: relative;
  pointer-events: none; /* Désactive les clics sur le bouton */
  background-color: #ccc; /* Change la couleur de fond pour indiquer le désactivé */
  color: #666; /* Change la couleur du texte pour indiquer le désactivé */
}

.p-invalid {
  border-color: red;
}

.button-loading .spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin-top: -10px; /* Pour centrer verticalement */
  margin-left: -10px; /* Pour centrer horizontalement */
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid #ba34db; /* Blue */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#button-plan-vente-container {
  justify-content: space-between;
}
@media screen and (max-width: 768px) {
  #button-plan-vente-container {
    justify-content: center;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
